import { useState } from 'react';
import CommonGroundReason from './CommonGroundReason';
import { DndContext, DragOverlay, closestCenter, PointerSensor, TouchSensor, useSensors, useSensor } from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';

function CommonGroundGroup(props) {
	const [activeId, setActiveId] = useState(null);

	const style = {
		container: "border border-gray-400 text-center rounded-lg",
		title: "rounded-md p-1.5 text-2xl font-bold text-center text-gray-800 bg-yellow-200",
		list: "max-h-128 overflow-y-scroll"
	};

	const sensors = useSensors(
		useSensor(PointerSensor),
		useSensor(TouchSensor)
	)

	function handleDragStart(event) {
    const {active} = event;
    setActiveId(active.id);
  }

	let title = "";
	if (props.type === "for") {
		title = "Case for MainClaim";
	} else {
		title = "Case against MainClaim";
	}

	function handleDragStart(event) {
    const {active} = event;
    setActiveId(active.id);
  }

	function handleDragEnd(event) {
		const {active, over} = event;

    if (active.id !== over.id) {
			const oldIndex = props.commonGrounds.findIndex(cg => cg.id === active.id);
			const newIndex = props.commonGrounds.findIndex(cg => cg.id === over.id);
			
			const commonGrounds = arrayMove(props.commonGrounds, oldIndex, newIndex);

			const updatedCommonGrounds = commonGrounds.map((cg, index) => ({
				...cg,
				priority: index,
			}));

			const priorities = updatedCommonGrounds.map(cg => ({ id: cg.id, type: props.type, priority: cg.priority }))
			props.updateCommonGroundPriorities(priorities);
    }
	}

	return (
		<div className={style.container}>
			<h2 className={style.title}>
				{title}
			</h2>
				{props.role == "referee" ? 
					(
						<>
							<DndContext sensors={sensors} collisionDetection={closestCenter} onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
								<SortableContext items={props.commonGrounds} strategy={verticalListSortingStrategy}>
									<ol className={style.list}>
										{props.commonGrounds.map(commonGround => <CommonGroundReason key={commonGround.id} role={props.role} commonGround={commonGround} openConfirmActionModal={props.openConfirmActionModal} />)}
									</ol>
								</SortableContext>
							</DndContext>
							<DragOverlay>
								{activeId ? <CommonGroundReason id={activeId} /> : null}
							</DragOverlay>
						</>
					)
					:
					(
						<ol className={style.list}>
							{props.commonGrounds.map(commonGround => <CommonGroundReason key={commonGround.id} role={props.role} commonGround={commonGround} />)}
						</ol>
					)
				}
		</div>
	)
}

export default CommonGroundGroup;
